import axios from 'axios';

// Create axios instance with default config
const api = axios.create({
    baseURL: 'https://plansync-backend-234288438538.us-central1.run.app',
    headers: {
        'Content-Type': 'application/json'
    }
});

export default api; 